// @flow
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FlexColumn } from 'styles/Layout';
import { APPLICATION_CATEGORIES } from 'utils/Constants';
import Routes from './Routes';
import SideBar from '../applications/components/sidebar';
import styled from 'styled-components';
import Header from './components/header';
import DashboardAction from 'modules/dashboards/api/actions/DashboardAction';
import DashboardStore from 'modules/dashboards/store/DashboardApplicationsStore';
import qs from 'query-string';
import { withFlux } from '@homie/flux';
import ScreeningParamsActions from 'modules/dashboards/api/actions/ScreeningParamsActions';
import ScreeningParamsStore from '../store/ScreeningParamsStore';

const Wrapper = styled(FlexColumn)`
  height: 100vh;
  background: #fff;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: block;
`;

const toCategory = (status: string) =>
  status === 'pending' ? 'incomplete' : status;

const toStatus = (category: string) =>
  category === 'incomplete' ? 'pending' : category;

const ApplicationsDashboard = ({
  history,
  location,
  match,
  queryObject,
  isNullQueryObject
}) => {
  useEffect(() => {
    ScreeningParamsActions.getDegreeLevels();
    ScreeningParamsActions.getSeniorityYears();
    ScreeningParamsActions.getPositionTypes();
    ScreeningParamsActions.getRelationShipMoral();
    ScreeningParamsActions.getRelationShipPhysical();
    ScreeningParamsActions.getEnterpriseSize();
    ScreeningParamsActions.getNumberOfBranches();
  }, []);

  useEffect(() => {
    if (!match.isExact) return;
    DashboardAction.updateQueryString(location.search);
  }, [location]);

  useEffect(() => {
    if (isNullQueryObject) return;

    DashboardAction.getApplicationsDashboard({
      status: toStatus(queryObject.active_step),
      page: queryObject.page,
      per_page: queryObject.per_page,
      sort_by: queryObject.sort_by,
      sort_direction: queryObject.sort_direction,
      term: queryObject.term
    });
  }, [queryObject]);

  const onOptionClick = (value: string): void => {
    DashboardAction.getApplicationsDashboard({
      status: toStatus(queryObject.active_step),
      page: queryObject.page,
      per_page: queryObject.per_page,
      sort_by: queryObject.sort_by,
      sort_direction: queryObject.sort_direction,
      term: queryObject.term
    });
    history.push({
      pathname: '/dashboard/aplicaciones',
      search: qs.stringify({
        ...queryObject,
        active_step: toCategory(value),
        page: 1,
        sort_by: null,
        sort_direction: null
      })
    });
  };

  const onChangeTerm = (value: string): void => {
    history.push({
      pathname: '/dashboard/aplicaciones',
      search: qs.stringify({
        ...queryObject,
        term: value,
        page: 1,
        sort_by: null,
        sort_direction: null
      })
    });
  };

  return (
    <Wrapper>
      <Content>
        <Header searchValue={queryObject.term} onChangeSearch={onChangeTerm} />
        <SideBar
          options={APPLICATION_CATEGORIES}
          onOptionClick={onOptionClick}
          currentStatus={toStatus(queryObject.active_step)}
          showTotals={!!queryObject.term}
        >
          <Routes />
        </SideBar>
      </Content>
    </Wrapper>
  );
};

ApplicationsDashboard.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  match: PropTypes.any,
  queryObject: PropTypes.any,
  isNullQueryObject: PropTypes.bool
};

export default withFlux([DashboardStore, ScreeningParamsStore], () => ({
  queryObject: DashboardStore.queryObject,
  isNullQueryObject: DashboardStore.isNullQueryObject,
  screeningParams: ScreeningParamsStore.screeningParams
}))(withRouter(ApplicationsDashboard));
